import React from 'react'
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form'

import { filterRangeOptions } from '@cinch/oxd-utils/form/src'
import { SelectField } from '@cinch-labs/design-system'

import styles from './select-field-wrapper.module.css'

export interface SelectBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  input: WrappedFieldInputProps
  meta?: WrappedFieldMetaProps
  options?: Array<{ label: string; value: string | number }>
  placeholder: string
  placeholderValue: any
  compareValue?: string | number
  compareForward?: boolean
}

const FilterSelectBox: React.FC<SelectBoxProps> = ({
  input,
  label,
  options = [],
  placeholder,
  placeholderValue = '',
  compareValue,
  compareForward,
}) => {
  const useOptions =
    typeof compareValue === 'undefined' ? options : filterRangeOptions(options, compareValue, !!compareForward)

  return (
    <SelectField
      label={label}
      id={input.name}
      options={useOptions}
      placeholder={placeholder}
      placeholderValue={placeholderValue}
      classNames={{
        select: styles.filterSelect,
        selectWrapper: styles.selectWrapper,
        arrow: styles.selectArrow,
      }}
      oxford={true}
      oxdClassName={styles.filterWrapper}
      error={{ show: false, collapse: true }}
      {...input}
      onFocus={() => null}
      onBlur={() => null}
    />
  )
}

export default FilterSelectBox
